module.exports = __webpack_public_path__ + "static/media/pic2.3d09e480.png";